import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { baseReviewabilityDefaults } from '../constants/Reviewability';
import * as UnreviewableReasons from '../constants/UnreviewableReason';
const themeReviewabilityDefaults = Object.assign({
  isPurchased: null
}, baseReviewabilityDefaults);
export default class ThemeReviewability extends createImmutableObjectClass(themeReviewabilityDefaults) {
  getUnreviewableReason() {
    const {
      isPurchased,
      maxPortalReviews,
      portalReviewsCount,
      testPortal,
      userAlreadyReviewed,
      userOnProviderPortal
    } = this;

    if (!isPurchased) {
      return UnreviewableReasons.NOT_INSTALLED;
    } else if (portalReviewsCount >= maxPortalReviews) {
      return UnreviewableReasons.LIMIT_REACHED;
    } else if (userAlreadyReviewed) {
      return UnreviewableReasons.ALREADY_REVIEWED;
    } else if (userOnProviderPortal) {
      return UnreviewableReasons.PROVIDER_USER;
    } else if (testPortal) {
      return UnreviewableReasons.TEST_PORTAL_USER;
    } else {
      return false;
    }
  }

  isReviewable() {
    return !this.getUnreviewableReason();
  }

}